export default function () {

    let anchorList = document.querySelectorAll(".read-also.cke-markup:not(.internal-url)");

    for (let item of anchorList) {

        item.classList.add("internal-url");

        let originalLinkContent = item.querySelector('.more-link');
        let linkContent;
        if (originalLinkContent) {
            linkContent = originalLinkContent.cloneNode(true);
            originalLinkContent.remove();

            let titleContent = document.createElement('div');
            let titleParagraph = document.createElement('p');
            titleParagraph.innerText = item.innerText;

            let titleImageWrap = document.createElement('span');
            let titleImage = document.createElement('img');
            titleImage.src = "assets/tv24/images/read-also-icon.svg";
            titleImage.alt = "read-also-icon";

            titleParagraph.appendChild(titleImageWrap);
            titleImageWrap.appendChild(titleImage);

            titleContent.className = 'read-also-title';
            titleContent.appendChild(titleParagraph);

            item.innerHTML = '';
            item.appendChild(titleContent);

            if (linkContent) {
                item.appendChild(linkContent);
            }

            let itemChildren = item.innerHTML;

            let wrapper = document.createElement('div');
            wrapper.className = 'read-also-content';

            wrapper.innerHTML = itemChildren;
            item.innerHTML = '';

            item.appendChild(wrapper);

            let imgWrapper = document.createElement('div');
            imgWrapper.className = 'img-wrapper';
            let anchor = item.getElementsByTagName('a')[0];
            if (!anchor)
                continue;

            let imgSrc = anchor.getAttribute("data-photosrc");

            if (!imgSrc)
                continue;

            imgWrapper.style.backgroundImage = `url(${imgSrc})`;
            item.prepend(imgWrapper);
        }
    }
}
